(function($){

	$(".navbar-toggler").click(function(){
		$(".navbar__sticky").toggleClass("show");
	});

	// Scrolltop button
	/*
	$('#btn-up').click(function(e){
		e.preventDefault();
		$('body,html').animate({scrollTop:0}, 500);
	});
	$(window).scroll(function () {
		if ($(window).scrollTop() > 301) {
			$('#btn-up').removeClass('disabled');
		}
		if ($(window).scrollTop() < 300) {
			$('#btn-up').addClass('disabled');
		}
	});
	*/

	$('.st-contacts--dropdown .st-contacts__items').each(function(){
		$(this).css('height', 'auto');
		$(this).data('height', $(this).height()).addClass('inited');
		$(this).css('height', 0);
	});
	$('.st-contacts--dropdown h2').click(function(){

		var dropdown = $(this).parents('.st-contacts--dropdown');
		var wasOpen = dropdown.hasClass('open');

		$('.st-contacts--dropdown').removeClass('open').find('.st-contacts__items').css('height', 0);

		if(wasOpen){
			dropdown.removeClass('open');
			dropdown.find('.st-contacts__items').css('height', 0);
		} else{
			dropdown.addClass('open');
			dropdown.find('.st-contacts__items').css('height', dropdown.find('.st-contacts__items').data('height'));
		}

	});

	var logosSwiper = new Swiper('.more-logos .swiper-container', {
		slidesPerView: 1,
		spaceBetween: 30,
		navigation: {
			nextEl: '.more-logos .swiper-button-next',
			prevEl: '.more-logos .swiper-button-prev',
		},
		breakpoints: {
			// when window width is >= 320px
			400: {
				slidesPerView: 2,
				spaceBetween: 15
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 30
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 30
			},
			1640: {
				slidesPerView: 5,
				spaceBetween: 30
			}
		}
	});

	var swiper = new Swiper('.gallery', {
		slidesPerView: 1,
		spaceBetween: 30,
		navigation: {
			nextEl: '.section--gallery .swiper-button-next',
			prevEl: '.section--gallery .swiper-button-prev',
		},
		breakpoints: {
			// when window width is >= 320px
			400: {
				slidesPerView: 2,
				spaceBetween: 15
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 30
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 30
			},
			1640: {
				slidesPerView: 5,
				spaceBetween: 30
			}
		}
	});


	var galleryNav = new Swiper('.product__images-thumbs', {
		//slidesPerView: 'auto',
		spaceBetween: 30,
		slidesPerView: 3,
		loop: false,
		freeMode: true,
		centeredSlides: true,
		centeredSlidesBounds: true,
		loopedSlides: 5, //looped slides should be the same
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});

	var galleryMain = new Swiper('.product__images-main', {
		spaceBetween: 30,
		loop:false,
		loopedSlides: 5, //looped slides should be the same
		autoHeight: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		},
		thumbs: {
			swiper: galleryNav
		}
	});

	galleryMain.on('slideChange', function () {
		galleryNav.slideTo(galleryMain.activeIndex);
	});


	// tabs + table wrap
	$('.tabs table').each(function(){
		$(this).wrap('<div class="table-responsive"></div>');
	});

	var tabsNav = new Swiper('.tabs__navigation', {
		spaceBetween: 10,
		slidesPerView: 'auto',
		loop: false,
		freeMode: true,
		loopedSlides: 5, //looped slides should be the same
		watchSlidesVisibility: true,
		watchSlidesProgress: true
	});

	var tabsContents = new Swiper('.tabs__contents', {
		spaceBetween: 40,
		allowTouchMove: false,
		loop:false,
		loopedSlides: 5, //looped slides should be the same
		autoHeight: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		},
		thumbs: {
			swiper: tabsNav
		},
		hashNavigation: {
			replaceState: true,
			watchState: true
		}
	});
	tabsContents.on('slideChange', function () {
		tabsNav.slideTo(tabsContents.activeIndex);
	});

})(jQuery);